import PrimeVue from 'primevue/config';
import locale from '../utils/locale';
import BadgeDirective from 'primevue/badgedirective';
import Tooltip from 'primevue/tooltip';

import store from '../store'

// 基础组件
import twInput from './basic/tw-input.vue'
import twButton from './basic/tw-button.vue'
import twCheckbox from './basic/tw-checkbox.vue'
import twRadio from './basic/tw-radio.vue'
import twDatePicker from './basic/tw-date-picker.vue'
import twLabel from './basic/tw-label.vue'
import twColorPicker from './basic/tw-color-picker.vue'
import twInputNumber from './basic/tw-input-number.vue'
import twSwitch from './basic/tw-switch.vue'
import twSlider from './basic/tw-slider.vue'
import twTag from './basic/tw-tag.vue'
import twProgress from './basic/tw-progress.vue'
import twPagination from './basic/tw-pagination.vue'
import twBadge from './basic/tw-badge.vue'
import twAvatar from './basic/tw-avatar.vue'
import twAlert from './basic/tw-alert.vue'
import twImage from './basic/tw-image.vue'
import twDivider from './basic/tw-divider.vue'
import twBacktop from './basic/tw-backtop.vue'
import twLink from './basic/tw-link.vue'
import twRate from './basic/tw-rate.vue'
import twVideo from './basic/tw-video.vue'
import twTimer from './basic/tw-timer.vue'
import twTextarea from './basic/tw-textarea.vue'
import twEditor from './basic/tw-editor.vue'
import twPassword from './basic/tw-password.vue'
import twIcon from './basic/tw-icon.vue'
import twDialog from './basic/tw-dialog.vue'

// 布局组件
import twContainer from './layout/tw-container.vue'
import twHeader from './layout/tw-header.vue'
import twAside from './layout/tw-aside.vue'
import twMain from './layout/tw-main.vue'
import twFooter from './layout/tw-footer.vue'
import twRow from './layout/tw-row.vue'
import twCol from './layout/tw-col.vue'
import twSubject from './layout/tw-subject.vue'
import twPanel from './layout/tw-panel.vue'
import twSlot from './layout/tw-slot.vue'
import twRouterView from './layout/tw-router-view.vue'
import twTheme from './layout/tw-theme.vue'
import twTabView from './layout/tw-tabview.vue'
import twTabPanel from './layout/tw-tabpanel.vue'
import twToolbar from './layout/tw-toolbar.vue'
import twFormItem from './layout/tw-form-item.vue'
import twMenu from './layout/tw-menu.vue'
import twMenuTopbar from './layout/tw-menu-topbar.vue'
import twMenuSidebar from './layout/tw-menu-sidebar.vue'

// 数据源组件
import twCellEdit from './data/tw-cell-edit.vue'
import twRowEdit from './data/tw-row-edit.vue'
import twGridEdit from './data/tw-grid-edit.vue'
import twGridView from './data/tw-grid-view.vue'
import twDropdown from './data/tw-dropdown.vue'
import twCarousel from './data/tw-carousel.vue'
import twPie from './data/tw-pie.vue'
import twHistogram from './data/tw-histogram.vue'
import twListView from './data/tw-list-view.vue'
import twCharts from './data/tw-charts.vue'
import twMultiselect from './data/tw-multiselect.vue'
import twGridViewAg from './data/tw-grid-view-ag.vue'
import twGridEditAg from './data/tw-grid-edit-ag.vue'
import twCellEditAg from './data/tw-cell-edit-ag.vue'
import twFullcalendar from './data/tw-fullcalendar.vue'
import twSplitbutton from './data/tw-splitbutton.vue'
import twFormView from './data/tw-form-view.vue'
import twUpload from './data/tw-upload.vue'

// 看板组件
import twWsContainer from './workshow/tw-ws-container.vue'
import twWsBlock from './workshow/tw-ws-block.vue'
import twWsPie from './workshow/tw-ws-pie.vue'
import twWsHistogram from './workshow/tw-ws-histogram.vue'
import twWsLine from './workshow/tw-ws-line.vue'
import twWsBorder from './workshow/tw-ws-border.vue'
import twWsNumber from './workshow/tw-ws-number.vue'
import twWsDashboard from './workshow/tw-ws-dashboard.vue'
import twWsProgress from './workshow/tw-ws-progress.vue'
import twWsClock from './workshow/tw-ws-clock.vue'
import twWsTitle from './workshow/tw-ws-title.vue'
import twWsTable from './workshow/tw-ws-table.vue'
import twWsFunnel from './workshow/tw-ws-funnel.vue'
import twWsRadar from './workshow/tw-ws-radar.vue'

// 设置向导（移至 tw-design 项目，由于设置向导需要调用设计器的相当接口，但又不想将设计器接口单独一个项目，所以暂时移至 tw-design 项目）
// import twRowWizard from './layout/wizards/row-wizard.vue'

// 属性编辑器（移至 src/components/aside/attribute-editor）
// import twSelectDataSourceEditor from './data/attribute-editor/select-data-source-editor.vue'
// import twSelectDataSourceGroupNameEditor from './data/attribute-editor/select-data-source-group-name-editor.vue'

// 所有属性编辑器列表（包括选择框下方快捷方式按钮提供的“编辑”、“向导”对话框）
const editors = [
    // twRowWizard
    // twSelectDataSourceEditor,
    // twSelectDataSourceGroupNameEditor,
]

// 所有组件列表
const components = [
    twInput,
    twButton,
    twCheckbox,
    twRadio,
    twDatePicker,
    twLabel,
    twColorPicker,
    twInputNumber,
    twSwitch,
    twSlider,
    twTag,
    twProgress,
    twPagination,
    twBadge,
    twAvatar,
    twAlert,
    twImage,
    twDivider,
    twBacktop,
    twLink,
    twRate,
    twVideo,
    twSubject,
    twPanel,
    twSlot,
    twRouterView,
    twTimer,
    twTextarea,
    twEditor,
    twUpload,
    twPassword,
    twIcon,
    twDialog,

    twContainer,
    twHeader,
    twAside,
    twMain,
    twFooter,
    twRow,
    twCol,
    twTabView,
    twTabPanel,
    twTheme,
    twToolbar,
    twFormItem,
    twMenu,
    twMenuTopbar,
    twMenuSidebar,

    twDropdown,
    twMultiselect,
    twCarousel,
    twGridViewAg,
    twGridEditAg,
    twCellEditAg,
    twCellEdit,
    twRowEdit,
    twGridEdit,
    twGridView,
    twPie,
    twHistogram,
    twListView,
    twFormView,
    twCharts,
    twFullcalendar,
    twSplitbutton,

    twWsContainer,
    twWsBlock,
    twWsPie,
    twWsHistogram,
    twWsLine,
    twWsBorder,
    twWsNumber,
    twWsDashboard,
    twWsProgress,
    twWsClock,
    twWsTitle,
    twWsTable,
    twWsFunnel,
    twWsRadar
]
 
const twUI = {
    install: function(Vue) {
        // 引入Vuex
        Vue.use(store)
        
        Vue.use(PrimeVue, locale).directive('badge', BadgeDirective).directive('tooltip', Tooltip)

        // 遍历注册所有属性编辑器
        editors.map(component => Vue.component(component.name, component))

        // 遍历注册所有组件
        components.map(component => Vue.component(component.name, component))
    }
}
 
export default twUI